'use client';

import Title from '../ui/typography/title';
import useProducts from '@/hooks/useProducts';
import { useState } from 'react';
import Container from '../ui/container';
import ProductsSliders from '../ui/sliders/products-slider';
import { filterIsInStockProducts } from '@/utils/product';

const ProductsList = ({
  data,
  isMulti,
  sectionType,
  hasMore = false,
  locale,
  isMobile,
}) => {
  const Info = useProducts(data, sectionType, isMulti);
  // const slidesPerView = isMobile ? 2 : 6;

  const [swiper, set_swiper] = useState({});
  const slidesNo = swiper?.slides?.length;
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  return (
    <Container className='my-8 py-0 max-lg:my-5 max-md:my-4 max-sm:my-1.5'>
      <ProductsSliders
        set_swiper={set_swiper}
        isLoading={Info.isMutating}
        products={filterIsInStockProducts(Info?.allProducts)}
        slidesNo={slidesNo}
        setIsBeginning={setIsBeginning}
        setIsEnd={setIsEnd}
        slidesPerView='auto'
        locale={locale}
        isMobile={isMobile}
      >
        <Title
          isMulti={isMulti}
          slidesNo={slidesNo}
          isBeginning={isBeginning}
          isEnd={isEnd}
          data={data}
          multiData={data?.value || []}
          title={
            isMulti
              ? data?.[`title-${locale}`]
              : data?.value?.[0]?.[`title-${locale}`]
          }
          active={Info?.active}
          setActive={Info?.setActive}
          swiper={swiper}
          locale={Info?.locale}
          hasMore={hasMore}
          href={data?.value?.[0]?.url ? `/${data?.value?.[0]?.url}` : '#'}
        />
      </ProductsSliders>
    </Container>
  );
};

export default ProductsList;
